import { useLoggedUser, useSessionPermission } from '@btime/react-session'
import React from 'react'

import { useForm, useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { useNavigationWithModalCloser } from '../../../utils/contexts/NavigationContext'
import Button from '../../../packages/kiti/components/actions/Button'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const ModalFooter = ({ onSubimit, loading, ...props }) => {
  const navigate = useNavigationWithModalCloser()
  const form = useForm()
  const formState = useFormState()
  const loggedUser = useLoggedUser()
  const isLeanServiceOrder = useSessionPermission('createLeanServiceOrder')
  const hideSaveOnLean = useSessionPermission('hideSaveOnLeanServiceOrder')

  const selectedUser = form.userOrGroup?.__typename === 'User' ? form.userOrGroup : {}
  const isSelfCreation = !form.id && loggedUser.id === selectedUser?.id
  const isForSelf = isSelfCreation && !props.loading
  const onSuccess = record => navigate(`/service-orders/${record?.id}/execution`)

  // Criação enxuta: perfis com a permissão ativada só podem "Salvar e executar".
  // Esconde o "Salvar" e promove "Salvar e executar" a ação principal. Só oculta quando
  // há o "Salvar e executar" (isSelfCreation), nunca deixando a criação sem botão de salvar.
  const hideSave = isLeanServiceOrder && isSelfCreation && hideSaveOnLean
  const showSaveAndExecute = hideSave ? isSelfCreation : isForSelf

  return (
    <SubmitBar loading={loading} {...props} hideSubmit={hideSave}>
      {showSaveAndExecute && (
        <Button
          loading={loading}
          transparent={!hideSave}
          color={hideSave ? undefined : 'dark3'}
          onClick={() => onSubimit(form, formState, { onSuccess })}
        >
          Salvar e executar
        </Button>
      )}
    </SubmitBar>
  )
}

export default ModalFooter
